import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { saveServiceBO, saveServiceGroup } from './manage-service.modal';

@Injectable({
  providedIn: 'root'
})
export class ManageService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }
  saveServiceGroup(save: saveServiceGroup): Observable<any> {
    let url = "api/Service/SaveServiceGroup";
    return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  DeleteServiceGroup(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Service/DeleteServiceGroup?";
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  saveServices(save: saveServiceBO): Observable<any> {
    let url = "api/Service/SaveServiceAsync";
    return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  DeleteService(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Service/DeleteService?";
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetServiceGroupDropdown(): Observable<any> {
    let url = "api/Service/GetServiceGroupDropdown?";
    return this.http.get(url, { observe: 'response' },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  GetServiceCodeDropdown(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ServiceActivity/GetServiceCodeDropdown?";
    return this.http.get(url + paramsData, { observe: 'response' },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  saveServicesActivity(save: any): Observable<any> {
    let url = "api/ServiceActivity/saveMasterServiceActivity";
    return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteServiceActivity(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ServiceActivity/DeleteService?";
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveActivity(save: any): Observable<any> {
    let url = "api/Activity/SaveMasterActivity";
    return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteActivity(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Activity/DeleteMasterActivity?";
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getActivityStatusList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ServiceActivity/getServiceAvailableSelectedList?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getServiceSelectedTaxList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ServiceTax/getServiceSelectedTaxList?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //////////////////////////////get Service Type///////////////////////////////////////////////////////////////////
  getServiceTypeDropdown(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/LOV/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveServicesTax(save: any): Observable<any> {
    let url = "api/ServiceTax/saveServiceTax";
    return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getAllTaxNamesList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ServiceTax/GetTaxList?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


}
